import { Ref } from 'vue';

import FlowState from '@dh-io-otb/shared/src/models/store/modules/otbc/flow-state.model';
import ConfigurationState from '@dh-io-otb/shared/src/models/store/modules/configuration-state.model';
import { useStore } from '@dh-io-otb/shared/src/composables/store.composable';

export default class RoutingService {
  static defineRedirectUrl(otbcFlow: FlowState, configuration: ConfigurationState): string {
    const { group, subgroup, dealer, dealers, fixedDealer, relativePath } = otbcFlow;
    const urlSearchParams = window.location.href;
    const utmRegex = /utm_.*?(?=\?)/;
    const utmMatch = urlSearchParams.match(utmRegex);
    const utmMatchResult = utmMatch ? `?${utmMatch[0]}` : '';
    const utmParameters = configuration.utmParameters ? utmMatchResult : '';
    const routerRoot = window.location.origin;
    if (relativePath) {
      return `${routerRoot}${relativePath}${utmParameters}`;
    }
    return `${routerRoot}${configuration.links.vmosRelativePath}${utmParameters}${RoutingService.normalizeQueryParams({
      group,
      subgroup,
      // TODO: the dealer should not be an object, but the dealerLocator
      // in Request Mode commits an object to store
      dealer: typeof dealer === 'object' ? '' : dealer,
      dealers,
      fixedDealer,
    })}`;
  }

  static normalizeQueryParams(object: Record<string, string | string[]> | string[]): string {
    let queryParams = '';

    for (const [key, value] of Object.entries(object)) {
      if (typeof object[key] === 'object') {
        RoutingService.normalizeQueryParams(object[key]);
      } else {
        if (queryParams && object[key]) {
          queryParams = `${queryParams}&${key}=${value}`;
        } else if (object[key]) {
          queryParams = `?${key}=${value}`;
        }
      }
    }

    return queryParams;
  }

  static setQueryParamsIntoStore(queryParams: Ref): void {
    const { state, commit } = useStore();

    queryParams.value.context ? commit('context', queryParams.value.context) : commit('context', 'OWPC');

    if (queryParams.value.modelSeries || queryParams.value.modelType) {
      const model = {
        modelSeries: queryParams.value.modelSeries,
        modelType: queryParams.value.modelType,
      };
      commit('model', { ...state.otbcFlow.model, ...model });
      commit('modelSelected', true);
    }

    if (queryParams.value.locationText && queryParams.value.locationRadius) {
      const location = {
        locationText: queryParams.value.locationText,
        locationRadius: queryParams.value.locationRadius,
      };
      commit('location', location);
      commit('locationSelected', true);
    }
    if (queryParams.value.onlineCode) commit('onlineCode', queryParams.value.onlineCode);
    if (queryParams.value.dealer) commit('dealer', queryParams.value.dealer);
    if (queryParams.value.dealers) commit('dealers', queryParams.value.dealers);
    if (queryParams.value.fixedDealer) {
      commit('fixedDealer', queryParams.value.fixedDealer === 'true');
      commit('referrer', queryParams.value.referrer || document.referrer);
    }
    if (queryParams.value.relativePath) commit('relativePath', queryParams.value.relativePath);
    if (queryParams.value.group) commit('group', queryParams.value.group);
    if (queryParams.value.subgroup) commit('subgroup', queryParams.value.subgroup);
  }
}
